import { render, staticRenderFns } from "./main.vue?vue&type=template&id=eff27c4a&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=eff27c4a&prod&lang=scss&scoped=true"
import style1 from "./main.vue?vue&type=style&index=1&id=eff27c4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff27c4a",
  null
  
)

export default component.exports